import React, {useCallback, useEffect, useState} from 'react';
import {toast} from 'react-toastify'
import BasicButton from '../../../../components/BasicButton';
import FiltersContentLoader from '../../../../components/FiltersContentLoader';
import Popup from '../../../../components/Popup';
import ENDPOINT from '../../../../constants/endpoints';
import useApi from '../../../../hooks/useApi';
import Dialog from '../../../Dialog';
import JotFormCreate from '../JotFormCreate';

const JotformWidget = ({candidateId}) => {
  const api = useApi();
  const [loading, setLoading] = useState(true);
  const [formSending, setFormSending] = useState(false);
  const [jotform, setJotform] = useState(null);
  const [createPopupVisible, setCreatePopupVisible] = useState(false);
  const [deletePopupVisible, setDeletePopupVisible] = useState(false);

  const deleteJotform = useCallback(() => {
    setFormSending(true);
    api.getRequest(ENDPOINT.ENTITY.DELETE_CANDIDATE_JOT_FORM, {candidateId}, {
      handleSuccess: (response) => {
        setJotform(null);
        setDeletePopupVisible(false);
        toast.success(
          `You have de-linked the form with Submission ID ${response.SubmissionID} from this candidate.  If you want to re-link it, click create jotform, use existing jotform, and enter the submission ID.`,
          {
            autoClose: 10000,
          }
        );
      },
      handleComplete: () => {
        setFormSending(false);
      },
      handleError: () => {
        toast.error('JotForm could not be deleted');
      }
    });
  }, [candidateId, setJotform, setFormSending]);

  useEffect(() => {
    setLoading(true);

    api.getRequest(ENDPOINT.ENTITY.CANDIDATE_JOT_FORM, {candidateId}, {
      handleSuccess: (response) => {
        setJotform(response);
      },
      handleComplete: () => {
        setLoading(false);
      }
    });
  }, [candidateId, setJotform, setLoading]);

  if (loading) {
    return <FiltersContentLoader />;
  }

  return (
    <div className="sidebar__widget">
      <div className="sidebar__block">
        <h3 className="sidebar__title">Jot Form</h3>
      </div>
      <div className="sidebar__block" style={{display: 'flex', flexDirection: 'column', gap: '10px'}}>
        {!jotform && (
          <BasicButton disabled={formSending} controlFunc={() => {
            setCreatePopupVisible(true);
          }} btnText={'Create JotForm'} btnArrow={false} />
        )}
        {jotform && (
          <>
            <BasicButton disabled={formSending} btnHref={jotform.Url} btnText={'View JotForm'} btnArrow={false} target={'_blank'} />
            <BasicButton disabled={formSending} btnHref={jotform.EditUrl} btnText={'Edit JotForm'} btnArrow={false} target={'_blank'} />
            <BasicButton
              disabled={formSending}
              controlFunc={() => {
                setDeletePopupVisible(true);
              }}
              btnText={'Delete JotForm'}
              btnArrow={false}
            />
          </>
        )}
      </div>
      {createPopupVisible && (
        <Popup
          popupStyles={{
            width: 500,
            padding: '20px 30px 10px',
          }}
          actions={{
            dismiss: () => {
              setCreatePopupVisible(false);
            },
          }}
          bodyRender={(
            <Dialog>
              <JotFormCreate
                candidateId={candidateId}
                onSuccess={(response) => {
                  setJotform(response);
                  setCreatePopupVisible(false);
                }}
              />
            </Dialog>
          )}
        />
      )}
      {deletePopupVisible && (
        <Popup
          hasCloseButton={false}
          popupStyles={{
            width: 500,
            padding: '30px 30px 10px',
          }}
          actions={{
            dismiss: () => {
              setDeletePopupVisible(false);
            },
          }}
          bodyRender={(
            <Dialog>
              <div className="dialog__form">
                <div style={{textAlign: 'center'}}>
                  Are you sure you want to delete this form?
                </div>
                <div className={'dialog__form-buttons'} style={{display: 'flex', gap: '10px', paddingTop: '20px'}}>
                  <BasicButton
                    btnText={'No'}
                    btnArrow={false}
                    controlFunc={() => {
                      setDeletePopupVisible(false);
                    }} />
                  <BasicButton btnText={'Yes'} btnArrow={false} controlFunc={deleteJotform} disabled={formSending} />
                </div>
              </div>
            </Dialog>
          )}
        />
      )}
    </div>
  )
};

export default JotformWidget;
